// extracted by mini-css-extract-plugin
export default {"crumbs":"breadcrumbs_crumbs__zNhzw","crumb":"breadcrumbs_crumb__uRqgK","crumb_link":"breadcrumbs_crumb_link__BaK5i"};